
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-times/[day]",
      function () {
        return require("private-next-pages/travel-times/[day].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-times/[day]"])
      });
    }
  